<template>
  <span></span>
</template>

<script>
export default {
  name: 'checkOutStock',
  props: {
    pName: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.init()
  },
  watch: {
  },
  methods: {
    init () {
      let self = this
      self.$swal.fire({
        icon: 'info',
        title: 'Oops...',
        text: `${self.pName} 已贈送完畢`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
